import { useEffect, useState } from "react";
import { ProductAdvancedFields } from "../../../../../../OBJRep/ProductAdvancedFields";
import { TAKE_X_PAY_Y_PROMOTION } from "../../../../CanvasViewer/EncarteConstants";
import { parsePrice } from "./price.utils";

const takeXPayYOptions = ["-", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const isPayYBigger = (productAdvancedFields) => {
  return (
    productAdvancedFields.takeX &&
    productAdvancedFields.payY &&
    productAdvancedFields.payY > productAdvancedFields.takeX
  );
};

export const useTakeXPayYModal = ({
  products,
  currentProductId,
  isOpen,
  onSave,
}) => {
  const [productAdvancedFields, setProductAdvancedFields] = useState(
    ProductAdvancedFields(),
  );

  useEffect(() => {
    if (!isOpen || !products?.length) return;

    const currentProduct = products[currentProductId];
    if (!currentProduct) return;

    setProductAdvancedFields(
      ProductAdvancedFields(
        currentProduct.promotionType,
        currentProduct.takeX,
        currentProduct.payY,
        currentProduct.normalSellingPrice,
        currentProduct.promotionPrice,
      ),
    );
  }, [isOpen, products, currentProductId]);

  const updateProductAdvancedFields = (info, value) => {
    setProductAdvancedFields((prev) => ({ ...prev, [info]: value }));
  };

  const save = () => {
    if (isPayYBigger(productAdvancedFields)) return;

    onSave({
      takeX: productAdvancedFields.takeX,
      payY: productAdvancedFields.payY,
      promotionPrice: productAdvancedFields.promotionPrice,
      promotionType: TAKE_X_PAY_Y_PROMOTION,
    });
  };

  return {
    productAdvancedFields,
    updateProductAdvancedFields,
    isPayYBigger: isPayYBigger(productAdvancedFields),
    parsePrice,
    save,
    takeXPayYOptions,
  };
};
